"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrice = void 0;
const formatPrice = (price) => (price / 100).toFixed(2);
exports.formatPrice = formatPrice;
